/**
* Helpers Functions
*/
export default function () {
  const { $i18n: i18n } = useNuxtApp()

  /**
  * Host
  */
  const host = useState('host', () => '')

  /**
  * Lang
  */
  const lang = useState('lang', () => 'en')

  /**
  * Current Layout
  */
  const layout = useState('layout', () => {
    return 'notFound'
  })

  const getLayout = () => {
    const { path } = useRoute()
    
    if (useRoute().name) {
      layout.value = useRoute().path.split('/')[1] ? useRoute().path.split('/')[1] : 'index'
    } else if (path === '/') {
      layout.value = 'index'
    } else {
      layout.value = 'notFound'
    }
  }

  /**
  * Info Header Banner
  */
  const infoHeaderBanner = useState('infoHeaderBanner', () => {
    return {
      message: false,
      height: 0
    }
  })

  /**
  * Current Path
  */
  const currentPath = useState('currentPath', () => {
    return useRoute().path
  })

  /**
  * If loading Header (for product details via Teleport)
  */
  const headerRef = useState('headerRef', () => false)

  /**
  * Sidenav Panel
  */
  const sidenavPanel = useState('sidenavPanel', () => false)
  watch(sidenavPanel, (newSidenavPanel) => {
    if (newSidenavPanel) {
      isNotOverflow.value = isShowOverlay.value = true
      isShowOverlay.value = 'fullOverlay'
    } else {
      isNotOverflow.value = isShowOverlay.value = false
    }
  }, { deep: true })

  /**
  * Close modal and ovarlay
  */
  const closeModal = () => {
    showHeaderMobileMenu.value = isNotOverflow.value = isShowOverlay.value = sidenavPanel.value = false
  }

  /**
  * No Overflow
  * Disable overflow for body
  */
  const isNotOverflow = useState('isNotOverflow', () => false)

  /**
  * Overlay
  */
  const isShowOverlay = useState('isShowOverlay', () => false)

  /**
  * Block First Screen
  */
  const isBlockFirstScreen = useState('isBlockFirstScreen', () => false)

  /**
  * Block Page (Page is process)
  */
  const isProcessBlockPage = useState('isProcessBlockPage', () => { 
    return {}
  })

  /**
  * Header Progress Process
  */
  const loadingProgress = useState('loadingProgress', () => false)

  /**
  * Progress Process
  */
  const isProcess = useState('isProcess', () => false)

  /**
  * Show Header Mobile Menu
  */
  const showHeaderMobileMenu = useState('showHeaderMobileMenu', () => false)

  /**
  * Copy Page Link
  */
  const copyPageLink = async (event, link, title) => {
    if (event) {
      event.preventDefault()
    }
    
    await navigator.clipboard.writeText(link ? link : window.location.href)

    useEventQueue().add('toast', { severity: 'contrast', detail: title ? title : i18n?.t('pageUrlCopied'), life: 5000 })
  }

  /**
  * Return Object
  */
  return {
    host,
    lang,
    layout,
    infoHeaderBanner,
    currentPath,
    getLayout,
    headerRef,

    isNotOverflow,
    isShowOverlay,
    isBlockFirstScreen,
    sidenavPanel,
    loadingProgress,
    isProcessBlockPage,
    isProcess,
    showHeaderMobileMenu,
    closeModal,

    copyPageLink
  }
}

/*
* Update Url Params
*/
export function useUpdateUrl(params) {
  const router = useRouter()
  
  const paramsString = new URLSearchParams(filterNonEmptyParams(params)).toString()

  if (paramsString) {
    router.push(router.currentRoute.value.path + '?' + paramsString)
  } else {
    router.push(router.currentRoute.value.path)
  }
}
